import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  STOP_CALLS_REFRESH: createSagaAction('STOP_CALLS_REFRESH'),

  STOP_CALL_CREATE: createSagaAction('STOP_CALL_CREATE'),
  STOP_CALL_UPDATE: createSagaAction('STOP_CALL_UPDATE'),
  STOP_CALL_DELETE: createSagaAction('STOP_CALL_DELETE'),

  UPLOAD_STOP_CALL_ATTACHMENT: createSagaAction('UPLOAD_STOP_CALL_ATTACHMENT'),
  FETCH_STOP_CALL_ATTACHMENTS: createSagaAction('FETCH_STOP_CALL_ATTACHMENTS'),
  UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_STOP_CALL_ATTACHMENT: createSagaAction('DELETE_STOP_CALL_ATTACHMENT'),

  STOP_CALL_NOTES_REFRESH: createSagaAction('STOP_CALL_NOTES_REFRESH'),
  STOP_CALL_NOTE_CREATE: createSagaAction('STOP_CALL_NOTE_CREATE'),
  STOP_CALL_NOTE_UPDATE: createSagaAction('STOP_CALL_NOTE_UPDATE'),
  STOP_CALL_NOTE_DELETE: createSagaAction('STOP_CALL_NOTE_DELETE')
}

// Action Creators
export const actions = {
  jobStopCallsRefresh: ({ jobId, callback }) => ({
    type: constants.STOP_CALLS_REFRESH.ACTION,
    jobId,
    callback
  }),

  createStopCall: ({ jobId, content }) => ({
    type: constants.STOP_CALL_CREATE.ACTION,
    jobId,
    content
  }),

  updateStopCall: ({ jobId, stopCallId, content }) => ({
    type: constants.STOP_CALL_UPDATE.ACTION,
    jobId,
    stopCallId,
    content
  }),

  deleteStopCall: ({ stopCallId, jobId }) => ({
    type: constants.STOP_CALL_DELETE.ACTION,
    jobId,
    stopCallId
  }),

  // Attachment actions
  uploadStopCallAttachment: (formData, stopCallId) => ({
    type: constants.UPLOAD_STOP_CALL_ATTACHMENT.ACTION,
    formData,
    stopCallId
  }),

  fetchStopCallAttachments: stopCallId => ({
    type: constants.FETCH_STOP_CALL_ATTACHMENTS.ACTION,
    stopCallId
  }),

  updateStopCallAttachmentDescription: (attachmentId, stopCallId, description) => ({
    type: constants.UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    stopCallId,
    description
  }),

  deleteStopCallAttachment: ({ attachmentId, stopCallId }) => ({
    type: constants.DELETE_STOP_CALL_ATTACHMENT.ACTION,
    attachmentId,
    stopCallId
  }),

  // notes
  stopCallNotesRefresh: stopCallId => ({
    type: constants.STOP_CALL_NOTES_REFRESH.ACTION,
    stopCallId
  }),

  createNote: ({ stopCallId, content, userId }) => ({
    type: constants.STOP_CALL_NOTE_CREATE.ACTION,
    stopCallId,
    content,
    userId
  }),

  updateNote: ({ stopCallId, noteId, content }) => ({
    type: constants.STOP_CALL_NOTE_UPDATE.ACTION,
    stopCallId,
    noteId,
    content
  }),

  deleteNote: ({ noteId, stopCallId }) => ({
    type: constants.STOP_CALL_NOTE_DELETE.ACTION,
    stopCallId,
    noteId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.STOP_CALLS_REFRESH.SUCCESS:
      return {
        ...state,
        stopCalls: action.payload
      }
    case constants.STOP_CALL_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.STOP_CALL_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.STOP_CALL_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_STOP_CALL_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_STOP_CALL_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.FETCH_STOP_CALL_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.FETCH_STOP_CALL_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        attachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION.SUCCESS:
      return { ...state }

    case constants.DELETE_STOP_CALL_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_STOP_CALL_ATTACHMENT.SUCCESS:
      return { ...state, deletingAttachment: false }

    case constants.STOP_CALL_NOTES_REFRESH.SUCCESS:
      return {
        ...state,
        stopCallNotes: action.payload
      }
    case constants.STOP_CALL_NOTE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.STOP_CALL_NOTE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.STOP_CALL_NOTE_DELETE.SUCCESS:
      return {
        ...state
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobStopCallActions.js